export default __webpack_public_path__ + "static/media/loading.ec467a2b.gif";